import React from "react";

import VollmachtRequestForm from "../VollmachtRequestFormNP";

const NaturalPersonVollmachtTab = (props) => (
  <VollmachtRequestForm {...props} />
);

export default NaturalPersonVollmachtTab;
